import { get, patch, post, remove } from '@/api/base'

const areasApi = {
  getAllForCompany: async companyUuid => {
    const response = await get({ path: `companies/${companyUuid}/areas` })
    return response.success ? response.data.areas : []
  },
  get: async (siteUuid, areaUuid) => {
    const response = await get({
      path: `sites/${siteUuid}/areas/${areaUuid}`,
    })
    return response.success ? response.data.area : null
  },
  getAll: async siteUuid => {
    const response = await get({ path: `sites/${siteUuid}/areas` })
    return response.success ? response.data.areas : []
  },
  delete: async (siteUuid, areaUuid) => {
    return await remove({ path: `sites/${siteUuid}/areas/${areaUuid}` }).success
  },
  create: async (siteUuid, params) => {
    const response = await post({
      path: `sites/${siteUuid}/areas`,
      params,
    })
    return response.success ? response.data.area : null
  },
  update: async (siteUuid, areaUuid, params) => {
    const response = await patch({
      path: `sites/${siteUuid}/areas/${areaUuid}`,
      params,
    })
    return response.success ? response.data.area : null
  },
}

export default areasApi
